// import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";
import { Chip } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import { descriptionToSVGbyCategory } from "../../../../icons/IconMappingSVG";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { ReactComponent as CriticalAssetOutlinedIcon } from "../../../../icons/icon_files/critical_asset_outlined_16.svg";

const RelatedAssetChip = ({ asset, handleClick, style = null }) => {
  const colors = useColors();

  const AssetTypeIcon =
    asset.type === "Other" ? (
      <SvgToIcon IconLogo={CriticalAssetOutlinedIcon} width={"16px"} />
    ) : (
      <SvgToIcon
        IconLogo={descriptionToSVGbyCategory["asset"][asset.type]}
        width={"16px"}
      />
    );

  return (
    <Chip
      label={asset.name}
      onClick={() => handleClick(asset.asset_id)}
      icon={AssetTypeIcon}
      style={{
        background: colors.critical_asset_chip_enabled_fill,
        boxShadow: colors.critical_asset_chip_enabled_shadow,
        height: "22px",
        borderRadius: "8px",
        fontSize: "12px",
        color: colors.text_primary,
        padding: "0 4px 0 8px",
        ...style,
      }}
    />
  );
};

export default RelatedAssetChip;
